module.exports = __webpack_public_path__ + "img/file-fill.bf3e296b.svg";